var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1112 20.0004V18.4449C18.1112 17.6197 17.7834 16.8284 17.2 16.245C16.6165 15.6615 15.8252 15.3337 15.0001 15.3337H8.77786C7.95274 15.3337 7.16142 15.6615 6.57797 16.245C5.99452 16.8284 5.66675 17.6197 5.66675 18.4449V20.0004",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8889 12.2227C13.6072 12.2227 15.0001 10.8298 15.0001 9.1116C15.0001 7.39338 13.6072 6.00049 11.8889 6.00049C10.1707 6.00049 8.77783 7.39338 8.77783 9.1116C8.77783 10.8298 10.1707 12.2227 11.8889 12.2227Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7777 19.9996V18.4441C22.7772 17.7548 22.5477 17.0851 22.1254 16.5403C21.7031 15.9955 21.1118 15.6064 20.4443 15.4341",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.999919 19.9845V18.4289C1.00043 17.7396 1.22986 17.07 1.65219 16.5252C2.07452 15.9804 2.66582 15.5913 3.33325 15.4189",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 6.10083C18.0025 6.27218 18.5956 6.66138 19.0192 7.20707C19.4428 7.75277 19.6727 8.42392 19.6727 9.11472C19.6727 9.80552 19.4428 10.4767 19.0192 11.0224C18.5956 11.5681 18.0025 11.9573 17.3333 12.1286",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.44434 6.08545C5.77512 6.25679 5.18197 6.64599 4.75839 7.19169C4.33482 7.73739 4.1049 8.40854 4.1049 9.09934C4.1049 9.79014 4.33482 10.4613 4.75839 11.007C5.18197 11.5527 5.77512 11.9419 6.44434 12.1132",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupsIcon);
export default __webpack_public_path__ + "static/media/groups-icon.49032bc014e786ad52ae909b6aea9bd4.svg";
export { ForwardRef as ReactComponent };